export default {
    title: "Sorry, we couldn't find this page",
    home: "Back to home",
}